import { HTML_LANG, t } from '../i18n'

/* "5 min", "8 sati", "2 dana" (card meta). */
export function timeAgo(iso, now = Date.now()) {
  const then = Date.parse(iso)
  if (Number.isNaN(then)) return ''
  const minutes = Math.max(1, Math.floor((now - then) / 60000))
  if (minutes < 60) return t('time.minutes', { count: minutes })
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return t('time.hours', { count: hours })
  return t('time.days', { count: Math.floor(hours / 24) })
}

/* "2026-10-19": the reader's local calendar day of a time. */
export function localDay(iso) {
  const d = new Date(iso)
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
}

/* "Danas", "Jučer", or "Ponedjeljak, 12. 10." (day separators, spec 9.3a). */
export function dayLabel(iso, now = new Date()) {
  const d = new Date(iso)
  const yesterday = new Date(now)
  yesterday.setDate(now.getDate() - 1)
  if (localDay(d) === localDay(now)) return t('time.today')
  if (localDay(d) === localDay(yesterday)) return t('time.yesterday')
  let weekday = ''
  try {
    weekday = new Intl.DateTimeFormat(HTML_LANG, { weekday: 'long' }).format(d)
  } catch (e) {
    weekday = ''
  }
  const date = `${d.getDate()}. ${d.getMonth() + 1}.`
  return weekday ? `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)}, ${date}` : date
}
